import { render, staticRenderFns } from "./ScreenList.vue?vue&type=template&id=352d1196&scoped=true&"
import script from "./ScreenList.vue?vue&type=script&lang=js&"
export * from "./ScreenList.vue?vue&type=script&lang=js&"
import style0 from "./ScreenList.vue?vue&type=style&index=0&id=352d1196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d1196",
  null
  
)

export default component.exports